const ConfigDB = {
    settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper',
        sidebar: {
            type: 'compact-wrapper',
            iconType: 'iconcolor-sidebar',
        },
        sidebar_setting: 'default-sidebar',
    },
    color: {
        primary_color: '#0b2441',
        secondary_color: '#2ab9f0',
        mix_background_layout: 'light-only',
    },
    router_animation: 'fadeIn',
};

export default ConfigDB;